// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

const timeZoneCookie = "simply_learning_time_zone"
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
const detectedTimeZone = document.cookie.split("; ").find((cookie) => cookie.startsWith(`${timeZoneCookie}=`))?.split("=")[1]

if (timeZone && detectedTimeZone !== encodeURIComponent(timeZone)) {
  document.cookie = `${timeZoneCookie}=${encodeURIComponent(timeZone)}; path=/; max-age=31536000; samesite=lax`
  Turbo.visit(window.location.href, { action: "replace" })
}

document.addEventListener("turbo:before-fetch-request", (event) => {
  if (timeZone) event.detail.fetchOptions.headers["X-Time-Zone"] = timeZone
})
